import { JogId, AllJogIds } from ".";
import { MinWspDistrictJogIdsMap, WspDistrictJogs } from "./wsp-fake-agencies";

export const JogIdConversionMap = new Map<string, JogId>([
  ["0", JogId.Other],
  ["1", JogId.SeattleArea],
  ["2", JogId.KingCountyNortheast],
  ["3", JogId.KingCountySouth],
  ["4", JogId.Tacoma],
  ["5", JogId.JBLM],
  ["6", JogId.SnohomishCounty],
  ["7", JogId.KitsapPeninsula],
  ["8", JogId.ClarkCounty],
]);

const sanitizeJogIds = (jogIds: string): Set<string> => {
  // make sure we have a unique set
  const jogIdSet = new Set(jogIds.split(","));

  // Delete these just in case they were somehow added.
  if (jogIdSet.has(JogId.Other)) jogIdSet.delete(JogId.Other);
  if (jogIdSet.has(JogId.NOT_SELECTED)) jogIdSet.delete(JogId.NOT_SELECTED);

  return jogIdSet;
}

// This function ensures that if the "WSP group" is selected,
// we retrieve all WSP events with the minimum number of JOG IDs,
// to limit the number of total results returned,
// to avoid the backend  throwing an error when the query result is too large and returning 0 results.
// Paging with multiple parrell request to get all results could prevent this issue,
// but it's currently an edge case.
export const sanitizeJogIdsForEvents = (jogIds: string): string => {
  const jogIdSet = sanitizeJogIds(jogIds);

  if (jogIdSet.has(JogId.Wsp)) {
    // Remove fake JOG ID
    jogIdSet.delete(JogId.Wsp);

    // Make sure at least one JOG ID is included for each WSP District
    WspDistrictJogs.forEach((jogsInDistrict, i) => {
      if (!jogsInDistrict.some(jogId => jogIdSet.has(jogId))) {
        const wspDistrict = i + 1; // Relies on WspDistrictJogs being ordered by district number
        jogIdSet.add(MinWspDistrictJogIdsMap.get(wspDistrict) as string);
      }
    });
  }

  return [...jogIdSet.values()].sort().join(",");
}

export const sanitizeJogIdsForIncidents = (jogIds: string): string => {
  const jogIdSet = sanitizeJogIds(jogIds);

  if (jogIdSet.has(JogId.Wsp)) {
    // Need to send a request with all JOG IDs if the "WSP" group is selected. Because the WSP group selects
    // all WSP districts, which means it covers all areas (the whole state), which means all possible incidents.
    return AllJogIds.join(",");
  }

  return [...jogIdSet.values()].sort().join(",");
}